import { TextareaHTMLAttributes } from 'react';
import styled from 'styled-components';

export interface ITextAreaInput
  extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'children'> {
  label?: string;
  id?: string;
  name?: string;
}

const TextAreaInput = ({ label, id, name, ...props }: ITextAreaInput): JSX.Element => {
  const textAreaId = id || (label ? label.replace(/\s+/g, '-').toLowerCase() : undefined);

  return (
    <>
      {label && <Label htmlFor={textAreaId}>{label}</Label>}
      <TextArea id={textAreaId} name={name} aria-label={label} {...props} />
    </>
  );
};

export default TextAreaInput;

const TextArea = styled.textarea`
  width: 100%;
  height: 147px;
  border-radius: 20px;
  outline: none;
  background-color: #fff;
  box-shadow: none;
  padding: 12px 14px;
  line-height: 1.5rem;
  font-size: 1rem;
  border: rgba(0, 0, 0, 0.1) solid 2px;
  transition: border-color 0.2s ease-in-out;

  &:focus {
    border-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  }

  &::placeholder {
    text-align: start;
    color: #000;
    opacity: 0.3;
  }

  &:disabled {
    background-color: #f5f5f5;
    border-color: rgba(0, 0, 0, 0.1);
    cursor: not-allowed;
  }

  resize: vertical;
`;

const Label = styled.label`
  font-family: var(--secondary-font);
  font-size: 18px;
  font-weight: 400;
  color: #000;
  margin: 0 0 1rem;
`;
